module.exports = __webpack_public_path__ + "static/media/gris_numero_celular.8cc3642f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/gris_numero_celular.svg
// module id = 1750
// module chunks = 0